import { render, staticRenderFns } from "./SignPad.vue?vue&type=template&id=4b51835f&scoped=true"
import script from "./SignPad.vue?vue&type=script&lang=js"
export * from "./SignPad.vue?vue&type=script&lang=js"
import style0 from "./SignPad.vue?vue&type=style&index=0&id=4b51835f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b51835f",
  null
  
)

export default component.exports